export default "__VITE_ASSET__zkzwtAHK__"